import React from "react";
import { House, Gavel, KeyRound, Users, Infinity as InfinityIcon, BadgeCheck } from "lucide-react";
import { Reveal } from "../hooks/useReveal";
import { bankBenefits } from "../data/siteContent";

const iconMap = { House, Gavel, KeyRound, Users, Infinity: InfinityIcon, BadgeCheck };

const TrustBank = () => {
  return (
    <section
      className="bg-inkdeep py-24 sm:py-36 relative overflow-hidden"
      data-testid="trust-bank-section"
    >
      <div
        className="absolute inset-0 opacity-[0.06]"
        aria-hidden="true"
        style={{
          backgroundImage:
            "radial-gradient(circle at 1px 1px, rgb(201, 162, 60) 1px, transparent 0px)",
          backgroundSize: "34px 34px",
        }}
      />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 relative">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-start">
          <div className="lg:sticky lg:top-32">
            <Reveal>
              <div className="flex items-center gap-3 text-[11px] sm:text-xs tracking-[0.3em] uppercase font-semibold text-gold">
                <span className="h-px w-10 bg-gold/60" />
                Trust as a Bank
              </div>
              <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-cream tracking-tight leading-[1.08] mt-6">
                Your Trust Is More Than a Document.{" "}
                <em className="text-gold italic">It Is Your Own Personal Bank.</em>
              </h2>
              <p className="text-cream/70 text-base sm:text-lg leading-relaxed mt-8">
                Most people think a trust just handles things after you are
                gone. That is a will. A living trust is different. It works
                for you while you are still alive.
              </p>
              <p className="text-cream/70 text-base sm:text-lg leading-relaxed mt-5">
                When set up correctly your trust becomes a structure that
                holds and grows your wealth, keeps it out of courts, shields
                it from lawsuits, and passes it to your family without delay.
                Wealthy families have used this for generations. Now everyday
                families can too.
              </p>
            </Reveal>
          </div>

          <div className="space-y-4">
            {bankBenefits.map((benefit, idx) => {
              const Icon = iconMap[benefit.icon];
              return (
                <Reveal key={idx} delay={idx * 60}>
                  <div
                    className="flex items-start gap-5 bg-surface/80 border border-white/8 rounded-xl px-6 py-5 hover:border-gold/40 hover:translate-x-1.5 transition-[border-color,transform] duration-400"
                    data-testid={`benefit-item-${idx}`}
                  >
                    <span className="text-gold mt-0.5 shrink-0">
                      <Icon className="w-[21px] h-[21px]" strokeWidth={1.9} />
                    </span>
                    <p className="text-cream/85 leading-relaxed text-sm sm:text-base">
                      {benefit.text}
                    </p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustBank;
